import InfosModal from '@features/infos-modal/infos-modal';
export default InfosModal;
